import * as actionTypes from "../actionTypes";

export const menuInitialValue = () => {
  return {
    type: actionTypes.MENU_INITIAL_VALUE,
  };
};
export const getMenuIngredients = (payload) => {
  return {
    type: actionTypes.GET_MENU_INGREDIENTS,
    payload,
  };
};
export const addMenuIngredientDetails = (query = "") => {
  return {
    type: actionTypes.ADD_MENU_INGREDIENT_DETAILS,
    query,
  };
};
export const saveMenuIngredientDetails = (payload) => {
  return {
    type: actionTypes.SAVE_MENU_INGREDIENT_DETAILS,
    payload,
  };
};

export const changeMenuValue = (valType, payload) => ({
  type: actionTypes.MENU_VALUE_CHANGE,
  valType,
  payload,
});

export const checkSupplierDetails = (query = "") => {
  return {
    type: actionTypes.CHECK_SUPPLIER_DETAILS,
    query,
  };
};

export const saveStorageAreaDetails = (payload) => {
  return {
    type: actionTypes.SAVE_STORAGE_AREA_DETAILS,
    payload,
  };
};

export const getConversionMultiplier = (payload) => {
  return {
    type: actionTypes.GET_CONVERSION_MULTIPLIER,
    payload,
  };
};

export const getInventoryUom = (payload) => {
  return {
    type: actionTypes.GET_INVENTORY_UOM,
    payload,
  };
};

export const saveBackupIngredient = (payload) => {
  return {
    type: actionTypes.SAVE_BACKUP_INGREDIENT,
    payload,
  };
};

export const getBackupIngredient = (query = "") => {
  return {
    type: actionTypes.GET_BACKUP_INGREDIENT,
    query,
  };
};

export const getEditIngredient = (query = "") => {
  return {
    type: actionTypes.GET_EDIT_INGREDIENT,
    query,
  };
};

export const getIngrRecMenuPendingApproval = (query = "") => {
  return {
    type: actionTypes.GET_INGRE_MENU_APPROVAL,
    query,
  };
};

export const changePendIngredientStatus = (payload) => {
  return {
    type: actionTypes.CHANGE_PEND_INGREDIENT_STATUS,
    payload,
  };
};

export const changeIngredientStatus = (payload) => {
  return {
    type: actionTypes.CHANGE_INGREDIENT_STATUS,
    payload,
  };
};

/* Recipe */

export const getMenuRecipes = (payload) => {
  return {
    type: actionTypes.GET_MENU_RECIPE,
    payload,
  };
};

export const addMenuRecipeDetails = (query = "") => {
  return {
    type: actionTypes.ADD_MENU_RECIPE_DETAILS,
    query,
  };
};

export const saveMenuRecipeDetails = (payload) => {
  return {
    type: actionTypes.SAVE_MENU_RECIPE_DETAILS,
    payload,
  };
};

export const getMeasurementUnit = (query = "") => {
  return {
    type: actionTypes.GET_MEASUREMENT_UNIT,
    query,
  };
};

export const getRecipeCostPrice = (payload) => {
  return {
    type: actionTypes.GET_RECIPE_COST_PRICE,
    payload,
  };
};

export const getRecipeMultiplier = (payload) => {
  return {
    type: actionTypes.GET_RECIPE_MULTIPLIER,
    payload,
  };
};

export const getRecipeUnitPrice = (payload) => {
  return {
    type: actionTypes.GET_RECIPE_UNIT_PRICE,
    payload,
  };
};

export const getEditRecipe = (query = "") => {
  return {
    type: actionTypes.GET_EDIT_RECIPE,
    query,
  };
};

export const changePendRecipeStatus = (payload) => {
  return {
    type: actionTypes.CHANGE_PEND_RECIPE_STATUS,
    payload,
  };
};

// Menu Item
export const getMenuItems = (payload) => {
  return {
    type: actionTypes.GET_MENU_ITEMS,
    payload,
  };
};

export const getMenuItemSubClass = (payload) => {
  return {
    type: actionTypes.GET_MENU_ITEM_SUB_CLASS,
    payload,
  };
};

export const getMenuItemSubCategory = (payload) => {
  return {
    type: actionTypes.GET_MENU_ITEM_SUB_CATEGORY,
    payload,
  };
};

export const updateMenuItemClass = (payload) => {
  return {
    type: actionTypes.UPDATE_MENU_ITEM_CLASS,
    payload,
  };
};

export const updateMenuItemCategory = (payload) => {
  return {
    type: actionTypes.UPDATE_MENU_ITEM_CATEGORY,
    payload,
  };
};

export const updateMenuItemStatus = (payload) => {
  return {
    type: actionTypes.UPDATE_MENU_ITEM_STATUS,
    payload,
  };
};

export const editMenuItemLifespan = (payload) => {
  return {
    type: actionTypes.EDIT_MENU_ITEM_LIFESPAN,
    payload,
  };
};
export const updateMenuItemLifespan = (payload) => {
  return {
    type: actionTypes.UPDATE_MENU_ITEM_LIFESPAN,
    payload,
  };
};

export const getAddMenuItem = (query = "") => {
  return {
    type: actionTypes.GET_ADD_MENU_ITEM,
    query,
  };
};

export const getEditMenuItem = (query = "") => {
  return {
    type: actionTypes.GET_EDIT_MENU_ITEM,
    query,
  };
};

export const saveAddMenuItem = (payload) => {
  return {
    type: actionTypes.SAVE_ADD_MENU_ITEM,
    payload,
  };
};

export const getMenuItemCa = (query = "") => {
  return {
    type: actionTypes.GET_MENU_ITEM_CA,
    query,
  };
};

export const getMenuMeasurementUnit = (query = "") => {
  return {
    type: actionTypes.GET_MENU_MEASUREMENT_UNIT,
    query,
  };
};

export const getMenuUnitPrice = (
  payload,
  unitPriceInput = "unit_price_detail", // dynamic set response input
  fromPage = "add_item_details" // dynamic set response input
) => {
  return {
    type: actionTypes.GET_MENU_UNIT_PRICE,
    payload,
    unitPriceInput,
    fromPage
  };
};

export const getMenuMultiUnit = (
  payload,
  multiUnitInput = "multiplier_detail",
  fromPage = "add_item_details" // dynamic set response input
) => {
  return {
    type: actionTypes.GET_MENU_MULTI_UNIT,
    payload,
    multiUnitInput,
    fromPage
  };
};

export const getCostPerMenuItem = (
  payload,
  costPriceInput = "cost_per_menu_item", // dynamic set response input
  fromPage = "item_modifiers_details" // dynamic set response input
) => {
  return {
    type: actionTypes.GET_COST_PER_MENU_ITEM,
    payload,
    costPriceInput,
    fromPage
  };
};

export const getAddMenuPricings = (query = "") => {
  return {
    type: actionTypes.GET_ADD_MENU_PRICINGS,
    query,
  };
};
export const getMenuEditPricings = (query = "") => {
  return {
    type: actionTypes.GET_MENU_EDIT_PRICINGS,
    query,
  };
};

export const saveAddMenuPricings = (payload) => {
  return {
    type: actionTypes.SAVE_ADD_MENU_PRICINGS,
    payload,
  };
};

export const saveEditMenuPricings = (payload) => {
  return {
    type: actionTypes.SAVE_EDIT_MENU_PRICINGS,
    payload,
  };
};

export const getEditMenuPricings = (query = "") => {
  return {
    type: actionTypes.GET_EDIT_MENU_PRICINGS,
    query,
  };
};
export const getEditMenuEditPricings = (query = "") => {
  return {
    type: actionTypes.GET_EDIT_MENU_EDIT_PRICINGS,
    query,
  };
};

export const getMenuPricingList = (query = "") => {
  return {
    type: actionTypes.GET_MENU_PRICING_LIST,
    query,
  };
};

export const getEditMenuPricingList = (query = "") => {
  return {
    type: actionTypes.GET_EDIT_MENU_PRICING_LIST,
    query,
  };
};

export const deleteMenuPricings = (payload) => {
  return {
    type: actionTypes.DELETE_MENU_PRICINGS,
    payload,
  };
};

export const deleteEditMenuPricings = (payload) => {
  return {
    type: actionTypes.DELETE_EDIT_MENU_PRICINGS,
    payload,
  };
};

export const getMenusList = (payload) => {
  return {
    type: actionTypes.GET_MENU_LIST,
    payload,
  };
};

export const getCostPerItem = (payload) => {
  return {
    type: actionTypes.GET_COST_PER_ITEM,
    payload,
  };
};

export const getMenuItemModifiers = (query = "") => {
  return {
    type: actionTypes.GET_MENU_ITEM_MODIFIERS,
    query,
  };
};
export const saveMenuItemModifier = (payload) => {
  return {
    type: actionTypes.SAVE_MENU_ITEM_MODIFIER,
    payload,
  };
};

export const deleteMenuItemModifier = (payload) => {
  return {
    type: actionTypes.DELETE_MENU_ITEM_MODIFIER,
    payload,
  };
};
export const deleteMenuBundleItemModifier = (payload) => {
  return {
    type: actionTypes.DELETE_MENU_BUNDLE_ITEM_MODIFIER,
    payload,
  };
};

export const getCopyBundleModifier = (query) => {
  return {
    type: actionTypes.GET_COPY_BUNDLE_MODIFIER,
    query,
  };
};

export const getBundleModifierForCopy = (query) => {
  return {
    type: actionTypes.GET_BUNDLE_MODIFIER_FOR_COPY,
    query,
  };
};

export const saveCopyBundleModifier = (query="",payload) => {
  return {
    type: actionTypes.SAVE_COPY_BUNDLE_MODIFIER,
    query,
    payload,
  };
};

export const editMenuBundleItemModifier = (query="") => {
  return {
    type: actionTypes.EDIT_MENU_BUNDLE_ITEM_MODIFIER,
    query,
  };
};
